import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  li: {
    lineHeight: '30px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  acceptArea: {
    marginTop: '13px',
    marginBottom: '10px',
    color: 'black !important',
  },

  insideH1: {
    marginBottom: 15,
    fontSize: '180%',
    fontWeight: 'normal',
    lineHeight: '30px',
  },

  insideH2: {
    marginBottom: 15,
    fontWeight: '300',
    fontSize: '26px',
    lineHeight: '32px',
  },

  insideBody: {
    marginBottom: 0,
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '18px',
  },

  logoContainer: {
    width: '200px',
    height: 'auto',
    overflow: 'hidden',
    textAlign: 'left',

    '& img': {
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
      objectFit: 'cover',
    },
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '480px',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%',
    height: '100%',
  },

  connectBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '16px',
    width: '480px',
  },

  connectionBox: {
    height: '80px',
    width: '480px',
    border: 'solid 1px #DBE5DE',
    borderRadius: '8px',
    padding: '16px',
  },

  iconConnection: {
    fontSize: '48px',
    color: theme.palette.primary.main,
  },

  textBody: {
    fontSize: '16px',
    color: '#5C5F5D',
    textAlign: 'center',
    margin: '8px 0 0',
  },

  textFoot: {
    fontSize: '12px',
    color: '#5C5F5D',
    textAlign: 'left',
  },

  formTitle: {
    marginTop: 10,
    marginBottom: 0,
    width: '100%',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '32px',
  },

  formSubTitle: {
    marginTop: 0,
    marginBottom: 5,
    width: '100%',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    opacity: 0.75,
  },

  buttons: {
    marginTop: '1rem !important',
    marginLeft: '-8px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    cursor: 'pointer',
  },
}))

export { useStyles }
